import type { Picture } from 'app/components/commons/Uploader/Types';
import type { OpeningHoursType } from 'app/typings/core/admin/experiences/openingHours/openingHours';
import type { Dayjs } from 'app/utils/dayjs';

export type IHotel = {
  id: number;
  name: string;
  countryId?: number;
  groupId: number;
  location: {
    locality: string;
    subLocality: string;
    coords: {
      lat: number;
      lng: number;
    };
  };
  contacts?: string[];
  bookingUrl: string;
  experiencesValue: number;
  snoozeNotifications?: string | Date;
  updatedAt: string | Date;
  brief: IMarketingBrief;
  services: {
    safety: string[];
    services: HotelServiceForm[];
  };
  spaces: ISpace[];
  streetPicture: Picture;
  checkInTime: string;
  checkOutTime: string;
  phone?: string;
};

export type IHotelsServicesType = {
  id: number;
  name: string;
  priority: number;
  openingHoursRequired: boolean;
  priceRequired: boolean;
  priceKinds?: string[];
  serviceKinds?: string[];
};

export type HotelServiceForm = {
  serviceTypeId: number;
  serviceKind?: string;
  openingHours?: OpeningHours;
  price?: number;
  priceKind?: string;
  customData?: string;
  id?: number;
  isDeleted?: boolean;
};

export type OpeningHours = {
  isAllDay?: boolean;
  slots?: Slot[];
  type: OpeningHoursType;
  days?: {
    [day: string]: {
      isAllDay?: boolean;
      slots?: Slot[];
    };
  };
};

export type Slot = {
  start?: string | null;
  end?: string | null;
};

export type IMarketingBrief = {
  websiteUrl: string;
  bookingUrl: string;
  bookingComUrl: string;
  instagramUrl: string;
  instagramLocationUrl: string;
  geographyDescription: string;
  propositionsDescription: string;
  universeDescription: string;
};

export enum Mode {
  View = 'view',
  Edit = 'edit',
}

export type ISpace = {
  spaceTypeId: number;
  name?: string;
  floor: number;
  phone?: string;
  infos?: string;
  openingHours?: OpeningHours;
  pictures?: Picture[];
  id?: number;
  addedSpace?: boolean;
};

export type ISpaceType = {
  category: string;
  floorRequired: boolean;
  id: number;
  multiple: boolean;
  name: string;
  nameRequired: boolean;
  openingHoursRequired: boolean;
  phoneRequired: boolean;
  picturesRequired: boolean;
};

export type SpaceSubmitType = {
  streetPictureId: string;
  checkInTime: string;
  checkOutTime: string;
  spaces: ISpace[];
};

export type IDeskFormatted = {
  checkInTime: Dayjs;
  checkOutTime: Dayjs;
} & ISpace;

export type SpaceValueType = {
  informativePhoto?: Picture[];
  desk?: IDeskFormatted;
  spaces?: ISpace[];
};
